import { useMemo } from 'react';

import { get } from 'lodash';
import { useCurrentSchoolYear } from 'sdk';

import { formatDate } from 'utils/date';

export const useMyPortfolioInitialFilters = ({ defaultValues }) => {
  const { data: currentSchoolYear, isLoading: currentSchoolYearLoading } =
    useCurrentSchoolYear();

  const filters = useMemo(() => {
    if (!currentSchoolYear || currentSchoolYearLoading) {
      return {};
    }

    return {
      ...defaultValues,
      startDate: formatDate({
        date: currentSchoolYear.naive_start_date
      }),
      endDate: formatDate({ date: currentSchoolYear.naive_end_date })
    };
  }, [currentSchoolYear, currentSchoolYearLoading, defaultValues]);

  return filters;
};

export const parseAndPrepareStudentPortfolioDateFilters = ({ filters }) => {
  const dateObjects = {
    startDate: formatDate({ date: filters.startDate }),
    endDate: formatDate({ date: filters.endDate })
  };

  return {
    start_date: formatDate({
      date: dateObjects.startDate,
      format: 'YYYY-MM-DD'
    }),
    end_date: formatDate({ date: dateObjects.endDate, format: 'YYYY-MM-DD' })
  };
};

export const getTaskName = (valueType, value) => {
  const valueNames = {
    checkbox: {
      1: 'correct',
      0: 'incorrect'
    },
    check_grade: {
      '-1': 'check minus',
      0: 'check',
      1: 'check plus'
    }
  };

  return get(valueNames, `${valueType}.${value}`, '');
};
